type TrackProperties = {
  tenant_id: string
  phone_number_id?: string
} & Record<string, any>

export default function useMixpanel () {
  const { $mixpanel } = useNuxtApp()
  const mixpanel: any = $mixpanel || null

  const track = (event: string, properties: TrackProperties) => {
    if (mixpanel) {
      mixpanel.track(event, properties)
    }
  }

  const identify = (userId: string, email: string, name: string) => {
    if (mixpanel) {
      mixpanel.identify(userId)
      mixpanel.people.set({ $email: email, $name: name })
    }
  }

  const reset = () => {
    if (mixpanel) {
      mixpanel.reset()
    }
  }

  return { track, identify, reset }
}
